module.exports = __webpack_public_path__ + "static/media/Background.a9ff2ccc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/Login/Background.svg
// module id = 639
// module chunks = 6